import { sendAnalytics } from 'shared/utils/analytics';

export const trackOfferCardClick = () => sendAnalytics({ action: 'to_card', label: 'house_offers' });
